<template>
    <div class="index-jygm">
        <SwitchTab :diagramType.sync="diagramType" @updateDiagramType="updateDiagramTypeFu"></SwitchTab>
        <JygmOneDiagram v-if="diagramType == 1" />
        <JygmTwoDiagram v-else-if="diagramType == 2" />
        <JygmThreeDiagram v-else-if="diagramType == 3" />
    </div>
</template>
<script>
import SwitchTab from "./switch-tab-jygm.vue";
import JygmOneDiagram from "./components/jygm-one-diagram.vue"
import JygmTwoDiagram from "./components/jygm-two-diagram.vue"
import JygmThreeDiagram from "./components/jygm-three-diagram.vue"
export default {
    components: {
        SwitchTab,
        JygmOneDiagram,
        JygmTwoDiagram,
        JygmThreeDiagram
    },
    data() {
        return {
            diagramType: 1
        }
    },
    mounted() {
        this.diagramType = this.$route.params.diagramType ? this.$route.params.diagramType : 1
    },
    methods: {
        updateDiagramTypeFu(type) {
            this.diagramType = type;
        }
    }
}
</script>
<style lang="scss">
.index-jygm {
    position: relative;
    width: 100%;
    height: 100%;
}
</style>